import { FC, PropsWithChildren, useCallback } from 'react'
import { useDropzone, FileWithPath } from 'react-dropzone'
import { cn, UploadFileProps } from '@wellesley/ui'

type CpmProps = PropsWithChildren<{
  className?: string
  addMedia: (props: UploadFileProps[]) => void
}>

const UploadDropzone: FC<CpmProps> = ({ addMedia, children, className }) => {
  const onDrop = useCallback((acceptedFiles: FileWithPath[]) => {
    const mappedFiles = acceptedFiles.map((f) => ({
      file: f,
      objectUrl: URL.createObjectURL(f),
    }))

    addMedia(mappedFiles)

    return () => mappedFiles.forEach((f) => URL.revokeObjectURL(f.objectUrl))
  }, [])

  const { isDragActive, getRootProps } = useDropzone({ onDrop })

  return (
    <div
      {...getRootProps({
        onClick: (e) => {
          e.stopPropagation()
        },
      })}
      className={cn(
        'border border-dashed focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0',
        isDragActive ? 'border-gray-500' : 'border-transparent',
        className,
      )}
    >
      {children}
    </div>
  )
}

export default UploadDropzone
